import React from "react";
import { Box, Typography } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface GapBarChartProps {
  predicted: number | null;
  actual: number | null;
}

/** Simple two-bar comparison of predicted vs. actual manager rating. */
const GapBarChart: React.FC<GapBarChartProps> = ({ predicted, actual }) => {
  const data = [
    { name: "Predicted Rating", value: predicted ?? 0 },
    { name: "Actual Rating", value: actual ?? 0 },
  ];

  if (predicted === null && actual === null) {
    return (
      <Typography variant="body2" color="text.secondary">
        No rating data available to compare.
      </Typography>
    );
  }

  return (
    <Box sx={{ width: "100%", height: 220 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis domain={[0, 5]} />
          <Tooltip />
          <Bar dataKey="value" radius={[4, 4, 0, 0]}>
            <Cell fill="#1976d2" />
            <Cell fill="#2e7d32" />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default GapBarChart;
